import API_ENDPOINTS from '../../endpoints/apiEndpoints';
import apiClient from '../../apiClient';
import { BaseResponse } from '../UtilsInterface';
import {
  QuestionAnswersBody,
  QuestionData,
  QuestionsListApiResponse,
} from '../QnaInterfaces';

const AdminQnaService = {
  // 문의 상세 조회
  getQuestionDetail: async (
    questionId: string
  ): Promise<BaseResponse<QuestionData>> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_admin_question_detail(questionId)
      );
      return response.data; // 응답 데이터 반환
    } catch (error) {
      console.error('문의 상세 조회 실패:', error);
      throw error;
    }
  },

  // 문의 내역 조회
  getQuestionsList: async (
    page: number,
    size: number,
    keyword?: string,
    questionType?: string
  ): Promise<QuestionsListApiResponse> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_admin_questions_list(
          page,
          size,
          keyword,
          questionType
        )
      );
      return response.data; // 응답 데이터 반환
    } catch (error) {
      console.error('문의 내역 조회 실패:', error);
      throw error;
    }
  },

  // 문의 사항 등록
  createAnswersQuestion: async (
    data: QuestionAnswersBody
  ): Promise<BaseResponse<string>> => {
    try {
      const response = await apiClient.post(
        API_ENDPOINTS.post_admin_question_answers_add(),
        data
      );
      return response.data; // 응답 데이터 반환
    } catch (error) {
      console.error('문의 사항 등록 실패:', error);
      throw error;
    }
  },

  updateAnswersQuestion: async (
    answerId: string,
    data: {
      content: string;
    }
  ): Promise<BaseResponse<string>> => {
    try {
      const response = await apiClient.put(
        API_ENDPOINTS.put_admin_question_answers_update(answerId),
        data
      );
      return response.data; // 응답 데이터 반환
    } catch (error) {
      console.error('문의 사항 등록 실패:', error);
      throw error;
    }
  },
};

export default AdminQnaService;
